import { render } from "./Galeria.vue?vue&type=template&id=3c00eff6&scoped=true"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"

import "./Galeria.vue?vue&type=style&index=0&id=3c00eff6&scoped=true&lang=css"

import exportComponent from "/Users/administrador/Documents/RepositoriosLMX/app-tent-register/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c00eff6"]])

export default __exports__